import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import { BiFilterAlt, BiSortDown, BiSortUp } from 'react-icons/bi';
import ReactPaginate from 'react-paginate';
import ListOfTickets from './ListOfTickets';
import SpecificTicketDetails from './SpecificTicketDetails';
import AssignUserPopup from './AssignUserPopup';
import ToolTip from '../../common/ToolTip';
import { getSearchedComplaint } from '../../api/Complaints';
import VendorAssignedPopup from './VendorAssignedPopup';
import Calender from './Calender';
import { FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getVendorComplaintList } from '../../api/VendorLogin';
import ComplaintsCardSkeleton from './ComplaintsCardSkeleton';
import { getComplaintList } from '../../api/hospitality/complaint';
import SlidedScreen from '../../common/SlidedScreen';
import { ImSpinner9 } from 'react-icons/im';

interface ComplaintProps {
  searchQuery?: any;
  isVendor?: boolean;
}

const Complaints = (props: ComplaintProps) => {
  const { searchQuery, isVendor } = props;

  const businessType = sessionStorage.getItem('businessType');
  const companyUuid = sessionStorage.getItem('companyUuid');
  const vendorUuid = sessionStorage.getItem('userUUID');
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const statusType = ['Pending', 'Assigned', 'Resolved', 'Reopened'];

  const [tickets, setTickets] = useState<any>([]);
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLoading, setShowLoading] = useState(true);
  const [showVendorAssignPopup, setShowVendorAssignPopup] = useState(false);
  const [selectedComplaintsInfo, setSelectedComplaintsInfo] = useState<any>();
  const [complaintInfo, setComplaintInfo] = useState<any>();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [clearButtonShow, setClearButtonShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [pageValue, setPageValue] = useState(1);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [resetData, setResetData] = useState(false);
  const [clearSerach, setClearSerach] = useState(false);
  const [clearAll, setClearAll] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [scrollList, setScrollList] = useState(false);

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const scrollPositionRef = useRef<number>(0);
  const lastPageRef = useRef(currentPage);

  const handleFetchTickets = async (
    type: string,
    page: number,
    from: string,
    to: string,
    defaultSelectionIndex: number,
    usePageLoader: boolean = true,
    reset?: boolean,
    sort?: string
  ) => {
    if (clearAll && (isFetching || !hasMore)) return;
    setIsFetching(true);
    if (usePageLoader && scrollContainerRef.current) {
      scrollPositionRef.current = scrollContainerRef.current.scrollTop;
    }
    try {
      if (usePageLoader && !scrollList) setShowLoading(true);
      if (businessType === 'Ecommerce') {
        const data = await getComplaintList(
          companyUuid || '',
          type,
          page,
          itemsPerPage,
          from,
          to,
          searchQuery || '',
          sort || sortOrder
        );
        // setTickets(data?.payload?.result || []);
        // setSelectedComplaintsInfo(data?.payload?.result[defaultSelectionIndex] || '');
        // setComplaintInfo(data?.payload?.result[defaultSelectionIndex] || '');
        if (data?.payload?.result.length > 0) {
          let list: any;
          const detail = isVendor ? complaintInfo : selectedComplaintsInfo;
          if (usePageLoader) {
            list = resetData || reset ? data.payload.result : [...tickets, ...data.payload.result];
            setShowDetails(false);
          } else {
            const record = data.payload.result.find((element: any) => element.uuid === detail.uuid);
            list = tickets.map((ele: any) => (ele.uuid === detail.uuid ? record : ele));
            setShowDetails(true);
          }
          const ind = detail ? list.findIndex((ele: any) => ele.uuid === detail.uuid) : 0;
          setTickets(list);
          setSelectedComplaintsInfo(list[ind === -1 ? 0 : ind] || '');
          setComplaintInfo(list[ind === -1 ? 0 : ind] || '');
          setTotalItems(data?.payload?.count || 0);
        } else {
          setTickets(data?.payload?.result || []);
          setHasMore(false);
          setClearAll(false);
        }
      } else {
        const data = isVendor
          ? await getVendorComplaintList(
              vendorUuid || '',
              page,
              itemsPerPage,
              type,
              '',
              '',
              '',
              sort || sortOrder
            )
          : await getSearchedComplaint(
              companyUuid || '',
              type,
              page,
              itemsPerPage,
              from,
              to,
              searchQuery,
              sort || sortOrder
            );

        // setTickets(data?.payload?.complaintList || []);
        // setSelectedComplaintsInfo(data?.payload?.complaintList[defaultSelectionIndex] || '');
        // setComplaintInfo(data?.payload?.complaintList[defaultSelectionIndex] || '');

        if (data?.payload?.complaintList.length > 0) {
          let list: any;
          const detail = isVendor ? complaintInfo : selectedComplaintsInfo;
          if (usePageLoader) {
            list =
              resetData || reset
                ? data.payload.complaintList
                : [...tickets, ...data.payload.complaintList];
            setShowDetails(false);
          } else {
            const record = data.payload.complaintList.find(
              (element: any) => element.uuid === detail.uuid
            );
            list = tickets.map((ele: any) => (ele.uuid === detail.uuid ? record : ele));
            setShowDetails(true);
          }
          const ind = detail ? list.findIndex((ele: any) => ele.uuid === detail.uuid) : 0;
          setTickets(list);
          setSelectedComplaintsInfo(list[ind === -1 ? 0 : ind] || '');
          setComplaintInfo(list[ind === -1 ? 0 : ind] || '');
          setTotalItems(data?.payload?.count || 0);
        } else {
          setTickets(data?.payload?.complaintList || []);
          setHasMore(false);
          setClearAll(false);
        }
      }
    } catch (error) {
    } finally {
      if (usePageLoader) setShowLoading(false);
      setIsFetching(false);
      setResetData(false);
      setScrollList(false);
      setTimeout(() => {
        if (usePageLoader && scrollContainerRef.current) {
          scrollContainerRef.current.scrollTop = scrollPositionRef.current;
        }
      }, 100);
    }
  };

  const normalizeToUTC = (date: Date | null): string => {
    if (date) {
      return moment(date).utc().format();
    } else {
      return '';
    }
  };

  const handleFilterClick = (type: string) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
    handleFetchTickets(type, 1, normalizeToUTC(startDate), normalizeToUTC(endDate), 0, true, true);
    setClearButtonShow(true);
    setSelectedFilter(type);
  };

  const handlePageClick = (event: { selected: number }) => {
    setCurrentPage(event.selected + 1);
    if (searchQuery !== '') {
      setPageValue(event.selected + 1);
    }
  };

  const handleStartDateChange = (selectedDate: Date | null) => {
    setStartDate(selectedDate);
    if (selectedDate || !selectedDate) {
      setEndDate(null);
    }
    if (!selectedDate) {
      handleFetchTickets('All', currentPage, '', '', 0, true, true);
      setSelectedFilter('All');
      setClearButtonShow(false);
    }
  };
  const handleEndDateChange = (selectedDate: Date | null) => {
    setEndDate(selectedDate);
    setCurrentPage(1);
    if (startDate && selectedDate) {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
      }
      handleFetchTickets(
        '',
        1,
        normalizeToUTC(startDate),
        normalizeToUTC(selectedDate),
        0,
        true,
        true
      );
    }
    setSelectedFilter('Sort');
    setClearButtonShow(true);
  };
  const handelClearFilter = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setClearAll(false);
    setStartDate(null);
    setEndDate(null);
    handleFetchTickets('All', 1, '', '', 0, true, true);
    setSelectedFilter('All');
    setClearButtonShow(false);
  };

  useEffect(() => {
    if (searchQuery !== '') {
      setPageValue(1);
      setCurrentPage(1);
      setClearSerach(true);
      handleFetchTickets(
        selectedFilter,
        1,
        normalizeToUTC(startDate),
        normalizeToUTC(endDate),
        0,
        true,
        true
      );
    } else if (clearSerach) {
      setClearSerach(false);
      handleFetchTickets(
        selectedFilter,
        1,
        normalizeToUTC(startDate),
        normalizeToUTC(endDate),
        0,
        true,
        true
      );
    }
  }, [searchQuery]);

  useEffect(() => {
    lastPageRef.current = currentPage;
    const fetchTickets = () => {
      if (isVendor) {
        handleFetchTickets(selectedFilter, currentPage, '', '', 0);
      } else if (searchQuery !== '') {
        handleFetchTickets(
          selectedFilter,
          pageValue,
          normalizeToUTC(startDate),
          normalizeToUTC(endDate),
          0,
          true,
          true
        );
      } else {
        handleFetchTickets(
          selectedFilter,
          currentPage,
          normalizeToUTC(startDate),
          normalizeToUTC(endDate),
          0
        );
      }
    };

    fetchTickets();
  }, [currentPage, pageValue, isVendor]);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollContainerRef.current || isFetching || !hasMore) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 30) {
        if (tickets.length < totalItems && lastPageRef.current === currentPage) {
          setScrollList(true);
          lastPageRef.current += 1;
          setCurrentPage((prev) => prev + 1);
        }
      }
    };

    const scrollableDiv = scrollContainerRef.current;
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isFetching, hasMore]);

  const pageCount = Math.ceil(totalItems / itemsPerPage);

  const handleSort = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setResetData(true);
    if (currentPage === 1) {
      const sort = sortOrder === 'asc' ? 'desc' : 'asc';
      setSortOrder(sort);
      handleFetchTickets(
        selectedFilter,
        currentPage,
        normalizeToUTC(startDate),
        normalizeToUTC(endDate),
        0,
        true,
        true,
        sort
      );
    } else {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
      setCurrentPage(1);
    }
  };

  return (
    <>
      <div className="bg-[#1E1E1E] h-screen py-0 w-full md:px-2 overflow-y-auto xl:overflow-hidden relative">
        <div className="flex md:flex-row flex-col justify-between items-center mb-2.5 px-2">
          <div className="flex justify-between md:w-[40%] w-full">
            <label className="text-xs md:text-base text-white font-medium">Tickets</label>
            <div className="flex justify-end sm:w-auto">
              <div onClick={handleSort} className=" text-white font-bold px-2 rounded">
                {sortOrder === 'asc' ? (
                  <BiSortDown className="cursor-pointer w-[30px] h-[30px]" color={'#006BEA'} />
                ) : (
                  <BiSortUp className="cursor-pointer w-[30px] h-[30px]" color={'#006BEA'} />
                )}
              </div>
            </div>
          </div>

          {!isVendor && (
            <div className="flex justify-between md:flex-row flex-col items-center gap-4">
              {clearButtonShow && (
                <button
                  className="bg-[#006BEA] text-[#FFFFFF] rounded-[6px] md:mt-0 mt-3 p-[5px] lg:p-[6px] xl:p-[10px] font-semibold text-[10px] ml-2 md:ml-2 md:text-[12px] "
                  onClick={handelClearFilter}
                >
                  Clear Filter
                </button>
              )}
              <div className="gap-3 flex items-center md:flex-row flex-col md:mt-0 mt-2">
                <div className="w-auto">
                  <Calender selectedDate={startDate} onDateChange={handleStartDateChange} />
                </div>
                <label className="font-medium">To</label>
                <div className="w-auto">
                  <Calender
                    selectedDate={endDate}
                    onDateChange={handleEndDateChange}
                    minDate={
                      startDate
                        ? new Date(new Date(startDate).setDate(startDate.getDate() + 1))
                        : null
                    }
                    disabled={!startDate}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-4">
                <div className="relative ">
                  <BiFilterAlt
                    className="cursor-pointer w-[30px] h-[30px]"
                    color={'#006BEA'}
                    onClick={() => setShowTooltip(true)}
                  />
                  <ToolTip
                    width={'md:w-[200px] lg:w-[200px] w-[150px]'}
                    height={'h-[150px]'}
                    isVisible={showTooltip}
                    onClose={() => setShowTooltip(false)}
                  >
                    <ul className="flex flex-col text-[#006BEA] font-bold text-base justify-center items-center mt-1 cursor-pointer">
                      {statusType.map((item) => (
                        <li
                          key={item}
                          onClick={() => {
                            handleFilterClick(item);
                            setShowTooltip(false);
                          }}
                          className="md:px-[62px] px-10 py-[5px] hover:bg-gray-100"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </ToolTip>
                </div>
                <div
                  className="h-8 w-8 bg-[#006BEA] rounded-lg flex justify-center items-center cursor-pointer"
                  onClick={() => navigate('/complaints/add-complaint')}
                >
                  <FaPlus className="h-4 w-4" />
                </div>
              </div>
            </div>
          )}
        </div>
        {showLoading ? (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
            </div>
            <ComplaintsCardSkeleton />
          </>
        ) : (
          <Fragment>
            {tickets.length > 0 ? (
              <div className="bg-[#1E1E1E] w-full overflow-y-auto xl:overflow-hidden mb-32 xl:mb-0">
                <div className="flex flex-col xl:flex-row gap-2.5 xl:h-[calc(100vh-185px)] pb-2 xl:pb-0 xl:mb-0">
                  <div
                    ref={scrollContainerRef}
                    className="w-auto  md:w-full lg:w-full xl:w-[40%] overflow-y-auto xl:h-[calc(100vh-180px)] 
                  max-h-[80vh] mb-3 xl:mb-0 lg:mb-0"
                  >
                    <ListOfTickets
                      tickets={tickets || []}
                      selectedComplaintsInfo={selectedComplaintsInfo}
                      setSelectedComplaintsInfo={(e: any) => {
                        setSelectedComplaintsInfo(e);
                        setShowDetails(true);
                      }}
                      complaintInfo={complaintInfo}
                      setComplaintInfo={(e: any) => {
                        setComplaintInfo(e);
                        setShowDetails(true);
                      }}
                      isVendor={isVendor}
                    />
                  </div>

                  <div className="w-[96%]  md:w-full xl:w-[58.5%] bg-[#343434] rounded-lg p-2 mt-2 ml-2 md:ml-0 hidden xl:block">
                    <SpecificTicketDetails
                      isVendor={isVendor}
                      tickets={tickets}
                      setShowAssignPopup={setShowAssignPopup}
                      setShowVendorAssignPopup={setShowVendorAssignPopup}
                      selectedComplaintsInfo={selectedComplaintsInfo}
                      complaintInfo={complaintInfo}
                      handleFetchTickets={handleFetchTickets}
                      currentPage={currentPage}
                      selectedFilter={selectedFilter}
                      itemsPerPage={itemsPerPage}
                    />
                  </div>
                  <SlidedScreen showDetails={showDetails} onClick={() => setShowDetails(false)}>
                    <SpecificTicketDetails
                      isVendor={isVendor}
                      tickets={tickets}
                      setShowAssignPopup={setShowAssignPopup}
                      setShowVendorAssignPopup={setShowVendorAssignPopup}
                      selectedComplaintsInfo={selectedComplaintsInfo}
                      complaintInfo={complaintInfo}
                      handleFetchTickets={handleFetchTickets}
                      currentPage={currentPage}
                      selectedFilter={selectedFilter}
                      itemsPerPage={itemsPerPage}
                    />
                  </SlidedScreen>
                </div>

                {isFetching && scrollList && (
                  <div className="flex justify-center lg:mt-3 md:gap-0 gap[-4px] xl:mb-1.5 w-full xl:w-[40%] mb-5 text-sm">
                    <div className="mr-2">
                      <ImSpinner9 className="h-5 w-5 text-[#006BEA] animate-spin" />
                    </div>
                    Loading more data...
                  </div>
                )}

                {/* {tickets.length > 0 && (
                  <div className="flex justify-center lg:mt-4 md:gap-0 gap[-4px] xl:mb-1.5 w-full xl:w-[40%] mb-36 text-sm">
                    <ReactPaginate
                      previousLabel={
                        <div className="flex items-center justify-center md:w-6 md:h-5 w-5 h-4 border rounded border-white text-white">
                          <FaChevronLeft />
                        </div>
                      }
                      nextLabel={
                        <div className="flex items-center justify-center md:w-6 md:h-5 w-5 h-4 border rounded border-white text-white">
                          <FaChevronRight />
                        </div>
                      }
                      pageCount={pageCount}
                      onPageChange={handlePageClick}
                      forcePage={currentPage - 1}
                      containerClassName="pagination flex space-x-6 mb-4"
                      pageLinkClassName="cursor-pointer"
                      activeLinkClassName="text-blue-500 font-bold"
                      disabledClassName="opacity-50 cursor-not-allowed"
                      previousClassName={currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}
                      nextClassName={
                        currentPage === pageCount ? 'opacity-50 cursor-not-allowed' : ''
                      }
                    />
                  </div>
                )} */}

                {showAssignPopup && (
                  <AssignUserPopup
                    tickets={tickets}
                    onClose={() => setShowAssignPopup(false)}
                    selectedComplaintsInfo={selectedComplaintsInfo}
                    handleFetchTickets={handleFetchTickets}
                    currentPage={currentPage}
                    selectedFilter={selectedFilter}
                    itemsPerPage={itemsPerPage}
                  />
                )}
                {showVendorAssignPopup && (
                  <VendorAssignedPopup
                    tickets={tickets}
                    onClose={() => setShowVendorAssignPopup(false)}
                    selectedComplaintsInfo={selectedComplaintsInfo}
                    handleFetchTickets={handleFetchTickets}
                    currentPage={currentPage}
                    selectedFilter={selectedFilter}
                    itemsPerPage={itemsPerPage}
                  />
                )}
              </div>
            ) : (
              <div
                className="flex content-center justify-center items-center h-4/6 overflow-y-hidden w-full text-gray-300 text-[14px] font-normal
              select-none"
              >
                No records found
              </div>
            )}
          </Fragment>
        )}
      </div>
    </>
  );
};

export default memo(Complaints);
